import { createReducer, updateState } from 'redux/handlers'
import types from './types'

const initialState = {
  term: '',
  termList: [],
  backLocation: {}
}

const updateTerm = (state, action) => {
  const { term } = action.payload
  return updateState(state, { term })
}

const updateTermList = (state, action) => {
  const { method, term } = action.payload
  const termList = [...state.termList]
  const termIndex = termList.findIndex(({ value }) => value === term.value)

  if (method === 'add') {
    if (termIndex === -1) {
      termList.unshift(term)
    } else {
      termList.splice(termIndex, 1)
      termList.unshift(term)
    }
  }

  return updateState(state, { termList })
}

const updateBackLocation = (state, action) => {
  const { location } = action.payload
  return updateState(state, { backLocation: location })
}

export default createReducer(initialState, {
  [types.SEARCH_ENGINE_UPDATE_TERM]: updateTerm,
  [types.SEARCH_ENGINE_UPDATE_TERM_LIST]: updateTermList,
  [types.SEARCH_ENGINE_UPDATE_BACK_LOCATION]: updateBackLocation
})
